// extracted by mini-css-extract-plugin
module.exports = {"MicrosoftActivityFeed":"AdministrationDashboard_MicrosoftActivityFeed__tNEt6"};